import React from "react";
import { Sparkle } from "@phosphor-icons/react";

export default function AISummary({ summary, loading }) {
  return (
    <div className="bg-surface border border-white/10 p-5" data-testid="ai-summary">
      <div className="flex items-center gap-2 mb-3">
        <Sparkle size={18} weight="duotone" color="#FFCC00" />
        <h3 className="heading text-lg font-semibold">How the market feels</h3>
        <span className="overline ml-auto">claude · sonnet 4.5</span>
      </div>
      {loading ? (
        <div className="space-y-2">
          <div className="h-3 bg-white/5 w-full" />
          <div className="h-3 bg-white/5 w-11/12" />
          <div className="h-3 bg-white/5 w-3/4" />
        </div>
      ) : (
        <p className="text-sm leading-relaxed text-white/85" data-testid="ai-summary-text">
          {summary || "Awaiting market data..."}
        </p>
      )}
    </div>
  );
}
